const LINK_LIST = 'linkList';
const FILTER_LIST = 'filterList';

export default {
    LINK_LIST,
    FILTER_LIST
};